<script setup lang="ts">
import Dialog from 'primevue/dialog';
import { ButtonType, CustomButton } from '@/components';

defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  fieldLabel: {
    type: String,
    required: true
  }
});

const emits = defineEmits(['onClose', 'onSave']);

const closeDialog = () => {
  emits('onClose');
};

const onSave = () => {
  emits('onSave');
};
</script>

<template>
    <div class="dialog-root">
        <Dialog :visible="visible"
            header="Are you sure?"
            modal
            class="dialog"
            append-to="self"
            @update:visible="closeDialog">
            <div class="delete-field">Deleting field: <span>{{ fieldLabel }}</span></div>
            <div class="delete-description">
                Deleting it will also cause all collected data for this field to be removed. Are you sure you want to proceed?
            </div>
            <div class="alert-buttons">
                <div class="alert-buttons-right">
                    <CustomButton text="Cancel"
                        @onClick="closeDialog"
                        :type="ButtonType.OUTLINED"/>
                    <CustomButton text="Delete"
                        @onClick="onSave"
                        :margin-left="16"
                        :type="ButtonType.NEGATIVE"/>
                </div>
            </div>
      </Dialog>
    </div>
</template>

<style scoped lang="scss">
@import "../../../assets/dialog";
:deep(.p-dialog) {
  max-width: 500px;
}
.delete-field {
    span {
        font-weight: 700;
    }
}
.delete-description {
    margin-top: 24px;
}
.alert-buttons {
    display: flex;
    justify-content: flex-end;
}
.alert-buttons-right {
    display: flex;
    margin-top: 32px;
}
</style>
